import { GenderEnum } from "../../core/constants/gender.enum";
import { KycStatus } from "../../core/constants/kyc-status.enum";
import { Address } from "../../features/application/models/address/address.model";
import { Country } from "../../features/application/models/address/country.model";
import { ContactPerson } from "../../features/application/models/contact-person.model";

/**
 * A role on an individual or body corporate (api-int RoleDTO). The lifecycle fields are filled on
 * post-registration snapshots: a role the applicant removed stays in the list with `isDeleted`.
 */
export interface StateJobTitle {
    id: number;
    titleCode: string;
    alias: string;
    appointmentDate?: string | null; // LocalDate in Java
    appointmentDocId?: number | null;
    removeDate?: string | null;      // LocalDate in Java
    removalReason?: string | null;
    isDeleted?: boolean | null;
}

export class StateIndividual {
    //@ts-ignore
    id: number;
    //@ts-ignore
    jobTitles: StateJobTitle[];
    identityDocIds?: number[] | null;
    worldCheckDocIds?: number[] | null;
    /** Post-reg snapshot only: the applicant removed this individual from the company. */
    isDeletedPostReg?: boolean | null;
    isResident?: boolean;
    firstName?: string;
    lastName?: string;
    noPatronymicName?: boolean;
    middleName?: string;
    firstNameInCyrillic?: string;
    lastNameInCyrillic?: string;
    middleNameInCyrillic?: string;
    formerName?: string;
    dateOfBirth?: string; // LocalDate in Java
    placeOfBirth?: string;
    gender?: GenderEnum;
    identityDocument?: Document;
    businessOccupation?: string;
    ownershipDate?: string; // LocalDate in Java
    contactPerson?: ContactPerson;
    address?: Address;
    email?: string;
    phone?: string;
    phoneCountryCode?: string;
    kycData?: {
        id: number | null;
        kycIndividualId: number | null,
        applicationId: number | null;
        statusEnum: KycStatus | string | null;
        kycEntryPointUrl: string | null;
        kycEntryPointUrlExpiresAt: Date | null;
        reportDocumentId: number | null;
        identityDocumentIds: number[] | null;
    };
    //@ts-ignore
    kycStatus: string;
}

export interface Document {
    type: IndividualDocumentType;
    docNumber: string;
    issueDate: string; 
    expireDate: string; 
    iin: string;
    country?: Country | null;
    issuedBy: string;
    vatNumber: string;
}

export enum IndividualDocumentType {
    IDENTITY_CARD = 'IDENTITY_CARD',
    PASSPORT = 'PASSPORT',
    UNKNOWN = 'UNKNOWN'
}